import { Flex } from '@grupoboticario/flora-react';

import { Skeleton } from 'components';
import { SLIDES_TO_SHOW } from 'config/environments/shared';
import { isMobile as isMobileHelper } from 'helpers';

import Styles from './CarouselToShare.styles';

export const CarouselToShareSkeleton = () => {
  const isMobile = isMobileHelper();

  return (
    <Flex direction='column' gap='$3'>
      <Skeleton height='$12' width='25%' />

      <Skeleton height='$7' width='50%' />

      <Flex justify='flex-start'>
        <Skeleton height='$8' width='$23' />
      </Flex>

      <Styles.SkeletonCarouselWrapper>
        <Skeleton width='$12' height='$12' />
        {[...Array(SLIDES_TO_SHOW[isMobile ? 'mobile' : 'desktop'])].map((_, index) => (
          <Styles.SkeletonImage key={index} data-testid='skeleton-image' />
        ))}
        <Skeleton width='$12' height='$12' />
      </Styles.SkeletonCarouselWrapper>
    </Flex>
  );
};
